// Product Slider - Swiper Module
import Swiper from "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs";

(() => {
  if (!customElements.get("product-slider-slider")) {
    class ProductSliderSlider extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
      }

      connectedCallback() {
        this.navigation = this.parentElement.querySelector(".product-images-buttons--slider-layout");
        this.prevButton = this.navigation?.querySelector(".slider-button--prev");
        this.nextButton = this.navigation?.querySelector(".slider-button--next");
        this.videoContainers = this.querySelectorAll(".product-single__media-external-video--play");

        requestAnimationFrame(() => {
          this.initSwiper();
          this.setupEvents();
          setTimeout(() => this.setupLightbox(), 100);
        });

        new MutationObserver(() => {
          setTimeout(() => this.setupLightbox(), 50);
        }).observe(this, {
          attributes: true,
          childList: true,
        });
      }

      initSwiper() {
        const swiperEl = this.querySelector(".swiper");
        if (!swiperEl) {
          console.warn("Swiper element not found");
          return;
        }

        const swiperWrapper = swiperEl.querySelector(".swiper-wrapper");
        if (!swiperWrapper) {
          console.warn("Swiper wrapper not found");
          return;
        }

        const slides = swiperWrapper.querySelectorAll(".swiper-slide");
        if (slides.length === 0) {
          console.warn("No slides found");
          return;
        }

        this.swiper = new Swiper(swiperEl, {
          slidesPerView: 1.1,
          spaceBetween: 0,
          speed: 300,
          grabCursor: true,
          observer: true,
          observeParents: true,
          navigation: {
            nextEl: this.nextButton,
            prevEl: this.prevButton,
          },
          breakpoints: {
            768: {
              slidesPerView: 1.5,
              spaceBetween: 12,
            },
          },
        });
      }

      setupEvents() {
        this.videoContainers.forEach((container) => {
          container.querySelector("button")?.addEventListener("click", () => {
            container.setAttribute("hidden", "");
          });
        });
      }

      selectCell(mediaId) {
        const slide = this.querySelector(mediaId);
        if (slide && this.swiper) {
          const slides = Array.from(this.querySelectorAll(".product-images__slide"));
          const index = slides.indexOf(slide);
          if (index >= 0) this.swiper.slideTo(index);
        }
      }

      reInit() {
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.initSwiper();
        }
      }

      setupLightbox() {
        if (typeof PhotoSwipe === "undefined") {
          console.warn("PhotoSwipe not loaded yet, retrying...");
          setTimeout(() => this.setupLightbox(), 500);
          return;
        }

        this.querySelectorAll(".product-single__media-zoom").forEach((link) => {
          const newLink = link.cloneNode(true);
          link.parentNode.replaceChild(newLink, link);
        });

        const zoomLinks = this.querySelectorAll(".product-single__media-zoom");
        if (!zoomLinks.length) {
          console.warn("No zoom links found");
          return;
        }

        const activeImages = Array.from(this.querySelectorAll(".product-images__slide--image")).filter((el) => el.clientWidth > 0);
        const items = activeImages.map((item) => {
          const link = item.querySelector(".product-single__media-zoom");
          return {
            src: link.getAttribute("href"),
            msrc: link.dataset.msrc,
            w: parseInt(link.dataset.w) || 800,
            h: parseInt(link.dataset.h) || 600,
            title: link.getAttribute("title") || "",
          };
        });

        zoomLinks.forEach((link, linkIndex) => {
          link.removeAttribute("target");

          link.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();

            const parent = link.closest(".product-images__slide--image");
            const index = activeImages.indexOf(parent);

            if (index >= 0) {
              const pswp = new PhotoSwipe(document.querySelector(".pswp"), PhotoSwipeUI_Default, items, {
                index,
                maxSpreadZoom: 2,
                captionEl: this.dataset.captions === "true",
                getThumbBoundsFn: (index) => {
                  const thumbnail = activeImages[index]?.querySelector(".product-single__media");
                  if (thumbnail) {
                    const rect = thumbnail.getBoundingClientRect();
                    return {
                      x: rect.left,
                      y: rect.top + window.scrollY,
                      w: rect.width,
                    };
                  }
                  return { x: 0, y: 0, w: 0 };
                },
              });
              pswp.init();
            }
          });
        });
      }

      disconnectedCallback() {
        this.swiper?.destroy(true, true);
      }
    }

    customElements.define("product-slider-slider", ProductSliderSlider);
  }
})();
